import { CheckBox, Text } from "@ui-kitten/components";
import React from "react";
import { StyleProp, View, ViewStyle } from "react-native";

interface MarketingConsentSectionProps {
  emailConsent: boolean;
  smsConsent: boolean;
  onEmailChange: (checked: boolean) => void;
  onSmsChange: (checked: boolean) => void;
  /** When provided, appends "from {tenantName} and FanRally" to the description. */
  tenantName?: string;
  /** Hide the email checkbox (e.g. user already opted in). Defaults to false. */
  hideEmail?: boolean;
  /** Hide the SMS checkbox (e.g. user already opted in). Defaults to false. */
  hideSms?: boolean;
  style?: StyleProp<ViewStyle>;
}

const MarketingConsentSection: React.FC<MarketingConsentSectionProps> = ({
  emailConsent,
  smsConsent,
  onEmailChange,
  onSmsChange,
  tenantName,
  hideEmail = false,
  hideSms = false,
  style,
}) => {
  const description = tenantName
    ? `Receive promotional emails, ticket offers, event updates, and membership information from ${tenantName} and FanRally.`
    : "Receive promotional emails, ticket offers, event updates, and membership information.";

  return (
    <View style={style}>
      <Text category="h6">Stay Updated</Text>
      <Text category="p2" style={{ marginTop: 8 }}>
        {description}
      </Text>
      <View style={{ marginTop: 12, gap: 8 }}>
        {!hideEmail && (
          <CheckBox checked={emailConsent} onChange={onEmailChange}>
            EMAIL
          </CheckBox>
        )}
        {!hideSms && (
          <CheckBox checked={smsConsent} onChange={onSmsChange}>
            SMS/TEXT
          </CheckBox>
        )}
      </View>
      <Text category="c1" style={{ marginTop: 8, color: "rgb(117, 117, 117)" }}>
        You may unsubscribe at any time using the unsubscribe link included in
        communications.
      </Text>
    </View>
  );
};

export default MarketingConsentSection;
